import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

export enum PlanPillVariant {
  FLOWCHART = 'FLOWCHART',
  HEADER = 'HEADER',
  MODAL = 'MODAL',
  TABLE = 'TABLE',
}

interface PlanPillProps {
  text?: string;
  variant: PlanPillVariant;
  className?: string;
  dataTestAttrs?: DataTestAttrs;
}

export default function PlanPill({
  text = 'Plan',
  variant,
  className,
  dataTestAttrs,
}: PlanPillProps): JSX.Element {
  let variantClassName: string;
  if (variant === PlanPillVariant.FLOWCHART) {
    variantClassName = css(styles.flowchart);
  } else if (variant === PlanPillVariant.HEADER) {
    variantClassName = css(styles.header);
  } else if (variant === PlanPillVariant.MODAL) {
    variantClassName = css(styles.modal);
  } else {
    variantClassName = css(styles.table);
  }
  return (
    <span
      className={classNames(css(styles.base), variantClassName, className)}
      {...getTestProps(dataTestAttrs)}
    >
      {text}
    </span>
  );
}

const styles = StyleSheet.create({
  base: {
    backgroundColor: Color.GRAY_100,
    display: 'inline-flex',
    alignItems: 'center',
    fontWeight: 600,
    width: 'fit-content',
  },
  flowchart: {
    color: Color.GRAY_700,
    fontSize: 12,
    borderRadius: 8,
    padding: '2px 10px',
  },
  header: {
    color: Color.GRAY_800,
    fontSize: 13,
    borderRadius: 4,
    padding: '4px 8px',
  },
  modal: {
    color: '#666',
    fontSize: 11,
    borderRadius: 4,
    padding: '2px 8px',
  },
  table: {
    color: Color.GRAY_800,
    fontSize: 12,
    borderRadius: 4,
    padding: '2px 6px',
  },
});
